import React from 'react';
import { useDispatch } from "react-redux";
import { DownloadOutlined } from '@ant-design/icons';
import Button from "components/button";
import APIService, {API_URL} from '../../services/apiservice';
import { showLoading, hideLoading } from '../../redux/layout/layoutState';
import { message } from 'antd';
import { removeTimestamp } from "utils/index";

function DownloadButton({downloadPath, filters, type='export', title='Export Data', className, attachmentData=null, ...props}) {
	const dispatch = useDispatch();

	const handleDownload = async () => {
		try {
			dispatch(showLoading('Downloading...'));
			if(attachmentData){
				processDownload(attachmentData.att_storage_path, removeTimestamp(attachmentData.att_filename));
			}else{
				const { paginate , ...restFilters } = filters || {};
				const {filePath, fileName, info_message} = await APIService.doExportRequest(`api/v1/${type}/${downloadPath}`, restFilters);
				
				if(info_message){
					message.success(info_message);
					return;
				}else{
					processDownload(filePath, fileName);
				}
			}
		} catch (error) {
	        console.error('Export failed:', error);
	    } finally {
	        dispatch(hideLoading());
	    }	
	}

	const processDownload = async (filePath, fileName) => {
		if(type == 'preview'){
			processPreview(filePath);
			
		}else{
			const downloadPath = type == 'download' ? `${API_URL}/download/${filePath}` : `${API_URL}${filePath}`;
			const response = await fetch(downloadPath);
				
			if (!response.ok) {
				throw new Error(`Failed to fetch file: ${response.statusText}`);
			}
			
			const blob = await response.blob();
			
			var downloadLink = document.createElement('a');
				downloadLink.href = window.URL.createObjectURL(blob);
				downloadLink.download = fileName;
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
		}
		
	}

	const processPreview = (filePath) => {
        window.open(`${API_URL}/preview/${filePath}`, '_blank', 'noopener,noreferrer');
    };
	
    return (
		<Button className={`crud-button btn-download me-3 ${className}`} onClick={handleDownload}>
			<DownloadOutlined className='me-1'/>{title}
		</Button>                    
    );
}

export default DownloadButton;